import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { FlashService } from "../../../flash/flash.service";
import { ExitFormService } from "../../../services/exit-form.service";

@Component({
  selector: "app-exit-interview",
  templateUrl: "./exit-interview.component.html",
  styleUrls: ["./exit-interview.component.css"],
})
export class ExitInterviewComponent implements OnInit {
  public form: FormGroup;
  currentUser;
  public fields: any[];
  
  tem: any;
  inValid: boolean = false;

  exp_ans = [];
  answers:any[] = [];
  showform;
  params:any;
  public elementName = [];

  constructor(
    private service: ExitFormService,
    private flashService: FlashService,
    private route: ActivatedRoute,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
  ) {}

  ngOnInit() {
    this.spinnerService.show();
    this.fields = JSON.parse(sessionStorage.getItem("pd_answer"));

       /* Taking values from the url */
       this.route.params.subscribe(
        params => {
          this.params = params.id;
          this.spinnerService.hide();
        }
      );


    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));

    this.fields = JSON.parse(sessionStorage.getItem("ex_int_answer"));

    this.form = new FormGroup({});
    this.fields.forEach((x) => {
      if (x.type == "checkbox") {
        this.form.addControl(x.name, new FormGroup({}));
        x.options.forEach((o) => {
          (this.form.get(x.name) as FormGroup).addControl(
            o.key,
            new FormControl(false)
          );
        });
      } else {
        this.form.addControl(
          x.name,
          new FormControl(
            x.value || "",
            x.required ? Validators.required : null
          )
        );
      }
    });

    this.generateForm();
    this.get_answer();
  }

  getFields() {
    return this.fields;
  }

  get_answer() {
    this.spinnerService.show();
    this.service.getAnswerEx(this.params).subscribe(
      (data) => {
        this.tem = data.body;
        this.answers = this.tem.questions;
        const arr = this.answers

        this.answers.forEach(element => {
          this.showform = element.status
          
        });

        this.spinnerService.hide();
      },
      (err) => {
        this.spinnerService.hide();
        console.log("Get Exit Interview Form Asnwer Error:", err);
      }
    );
  }

  onSubmit() {
    this.exp_ans = [];

    let keys_data = Object.keys(this.form.value);
    let value_data = Object.values(this.form.value);
    keys_data.forEach((element, index) => {
      var item = this.fields.find((item) => item.name === element);

      if ((typeof value_data[index] === "object") === true) {
        var obj = value_data[index];

        var keys = Object.keys(obj);

        var filtered = keys.filter(function (key) {
          return obj[key];
        });

        this.exp_ans.push({ name:item.name, id: item.id, ans: filtered });
      } else {
        this.exp_ans.push({ name:item.name, id: item.id, ans: value_data[index] });
      }
      if(value_data[index] === undefined){
        return this.inValid = true
     }
    });

    this.inValid = false;
    
    let obj = Object.values(this.form.value);

   obj.forEach((formValue) => {
      if (formValue === "") {
        this.inValid = true;
      }
    });

    this.elementName = [];

    this.exp_ans.forEach(ele => {
      if(!ele.ans){
        this.elementName.push(ele.name);
      }
    });

    if(this.elementName.length){
      this.inValid = true;
    }

    if(this.inValid === false) {
      this.updateExitInterviewForm()
     };
  }

  generateForm() {
    this.form = new FormGroup({
      fields: new FormControl(JSON.stringify(this.fields)),
    });

    this.form = new FormGroup({});
    this.fields.forEach((x) => {
      if (x.type == "checkbox") {
        this.form.addControl(x.name, new FormGroup({}));
        x.options.forEach((o) => {
          (this.form.get(x.name) as FormGroup).addControl(
            o.key,
            new FormControl(false)
          );
        });
      } else {
        this.form.addControl(
          x.name,
          new FormControl(
            x.value || "",
            x.required ? Validators.required : null
          )
        );
      }
    });
  }

  updateExitInterviewForm() {
    this.spinnerService.show();
    const payload = {
      emp_id: this.params.toString(),
      data: this.exp_ans,
    };

    this.service.updateExitForm(payload).subscribe(
      (data) => {
        if (data.body["success"]) {
          this.flashService.show(data.body["message"], "alert-success");
          this.get_answer()

        } else {
          this.flashService.show(data.body["message"], "alert-success");
          this.get_answer()
        }
        this.spinnerService.hide();
      },
      (err) => {
        this.spinnerService.hide();
        console.log("Create Exit Form Error:", err);
        this.flashService.show(err.error.body["message"], "alert-danger");
      }
    );
  }

  back(){
    this.router.navigate(['/offboarding'])
  }
}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/offboarding/forms-view/exit-interview/exit-interview.component.ts